import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AppWithoutAuth from './AppWithoutAuth';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { createStore, compose } from 'redux';
import allReducer from './store/reducers';
import { Provider } from 'react-redux';

import { Amplify } from 'aws-amplify';
import config from './aws-exports';

const composeEnhancers =
  process.env.REACT_APP_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__
    : compose;

const store = createStore(
  allReducer,
  composeEnhancers()
);

Amplify.configure(config);

const root = ReactDOM.createRoot(document.getElementById('root'));
const currentPath = window.location.pathname;

root.render(
  <Provider store={store}>
      <BrowserRouter>
        {!currentPath.includes("/survey/") && (
          <App />
        )}
        {currentPath.includes("/survey/") && (
          <AppWithoutAuth />
        )}
      </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
